import { Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    marker: {
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        left: 8,
        bottom: 8,
    },
    markerText: {
        alignSelf: 'center',
        fontFamily: Fonts.main.bold,
        fontSize: 12,
        color: COLOR.background,
    },
    isOnLiveCard: {
        bottom: Platform.select({
            web: 18,
            default: 20,
        }),
    },
});

export default styles;
